import * as React from 'react';
import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  TextInput, FileField, Show,
  usePermissions,
  DeleteButton,
} from "react-admin";
import CreateView from "../../../components/CreateView";
import { SERVER } from '../../../constants';
import { RaFileInput } from '../../../components/RaFileUploader';
import { ROLES } from '../../../constants';


export const InsertPaybillList = (props) => {
  const { permissions } = usePermissions();

  return (
    <List {...props} sort={{ field: 'updatedAt', order: 'DESC' }}>
      <Datagrid rowClick={null} sort={{ field: 'order', order: 'ASC' }}>
        {/* <DateField  locales={"fa-IR"} source="createdAt" /> */}
        <TextField source="title" label="عنوان" />
        <DateField options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" source="createdAt" label="تاریخ ایجاد" />
        {(permissions?.includes(ROLES.SUPER_ADMIN)
          || permissions?.includes(ROLES.HR_ADMIN) || permissions?.includes(ROLES.ROOT)) &&
          <FileField label="فایل" source="attachment" src="url" title="دریافت" target="_blank" />
         
        }
        {(permissions?.includes(ROLES.SUPER_ADMIN)
          || permissions?.includes(ROLES.HR_ADMIN) || permissions?.includes(ROLES.ROOT)) &&
          
         <DeleteButton />
        }
        {/* <ShowButton>نمایش</ShowButton> */}
      </Datagrid>
    </List>
  )
};


export const InsertPaybillShow = (props) => (
  <Show {...props} actions={null}>
    <SimpleShowLayout>
      <TextField source="title" label="عنوان" />
      <FileField label="فایل" source="attachment" src="url" title="دریافت" target="_blank" />

      <TextField source="attachment" label="لینک" />

      <DateField locales={"fa-IR"} source="createdAt" label="تاریخ ایجاد" />
      {/* <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" /> */}

    </SimpleShowLayout>
  </Show>
);


export const InsertPaybillCreate = (props) => {
  const { permissions } = usePermissions();

  return (
    <CreateView {...props}>
      <TextInput source="title" label="عنوان" required
      />
      {/* <FileInput source="attachfile" label="سند مربوطه" >
        <ImageField source="src" title="title" />
      </FileInput> */}
      {(permissions?.includes(ROLES.SUPER_ADMIN)
        || permissions?.includes(ROLES.HR_ADMIN) || permissions?.includes(ROLES.ROOT)) &&

        <FileField label="فایل " source="attachments" src="url" title="دریافت" target="_blank" />
      }
      {(permissions?.includes(ROLES.SUPER_ADMIN)
        || permissions?.includes(ROLES.HR_ADMIN) || permissions?.includes(ROLES.ROOT)) &&
        <RaFileInput
          required
          fullwidth={false}
          source="file"
          label="سند مربوطه"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          options={{ type: "insertPaybill" }}
          className={'classFile'}
          uploadEndpoint={`${SERVER}/admin/file`}
        />}

    </CreateView>
  )
};
// uploadEndpoint={'http://karafsgym.com:8090/admin/api/v1/file-upload'}
